import { get, post, del, patch } from './client.js';

const base = (wsId, dealId) => `/workspaces/${wsId}/deals/${dealId}`;

export const listContacts    = (wsId, dealId)            => get(`${base(wsId, dealId)}/contacts`);
export const addContact      = (wsId, dealId, body)      => post(`${base(wsId, dealId)}/contacts`, body);
export const updateContact   = (wsId, dealId, id, body)  => patch(`${base(wsId, dealId)}/contacts/${id}`, body);
export const removeContact   = (wsId, dealId, id)        => del(`${base(wsId, dealId)}/contacts/${id}`);

export const listCompetitors   = (wsId, dealId)          => get(`${base(wsId, dealId)}/competitors`);
export const addCompetitor     = (wsId, dealId, body)    => post(`${base(wsId, dealId)}/competitors`, body);
export const updateCompetitor  = (wsId, dealId, id, body) => patch(`${base(wsId, dealId)}/competitors/${id}`, body);
export const removeCompetitor  = (wsId, dealId, id)      => del(`${base(wsId, dealId)}/competitors/${id}`);

export const listProducts    = (wsId, dealId)            => get(`${base(wsId, dealId)}/products`);
export const addProduct      = (wsId, dealId, body)      => post(`${base(wsId, dealId)}/products`, body);
export const updateProduct   = (wsId, dealId, id, body)  => patch(`${base(wsId, dealId)}/products/${id}`, body);
export const removeProduct   = (wsId, dealId, id)        => del(`${base(wsId, dealId)}/products/${id}`);

export const listChecklist   = (wsId, dealId)       => get(`${base(wsId, dealId)}/checklist`);
export const addChecklistItem = (wsId, dealId, body) => post(`${base(wsId, dealId)}/checklist`, body);
export const toggleChecklist  = (wsId, dealId, id)   => patch(`${base(wsId, dealId)}/checklist/${id}/toggle`, {});
export const removeChecklist  = (wsId, dealId, id)   => del(`${base(wsId, dealId)}/checklist/${id}`);

export const reopenDeal = (wsId, dealId, stageId) => post(`${base(wsId, dealId)}/reopen`, { stageId });
